// extracted by mini-css-extract-plugin
module.exports = {"modal":"CashoutProviderInfoModal_modal__oNiT5","button":"CashoutProviderInfoModal_button__iYg0l"};